import axios from 'axios';
import {
  apiInstancesLinksSurveysQuestionsOptionsUrl,
  apiInstancesLinksSurveysQuestionsOptionsForInstanceLinkUrl
} from '../config';
import populatePropertys from '../utils/populatePropertys';

/**
 * GET Instance Links Surveys Questions Options
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props - properties Object
 * @param {{}} [props.requestConfig] - additional config for request
 * @param {boolean} [props.beforeThreshold] - return records before threshold value
 * @param {string} [props.instanceLinkUUID] - target instanceLinkUUID
 * @param {string} [props.linkedProfileUUID] - target linkedProfileUUID
 * @param {string} [props.profileUUID] - target profileUUID
 * @param {string} [props.questionSetId] - target questionSetId
 * @returns {Promise}
 */
const getInstancesQuestionsOptions = (props = {}) => {
  const { instanceLinkUUID, requestConfig } = props;

  const method = 'get';
  let url = apiInstancesLinksSurveysQuestionsOptionsUrl;

  if (instanceLinkUUID) {
    url = apiInstancesLinksSurveysQuestionsOptionsForInstanceLinkUrl.replace(
      /{instanceLinkUUID}/g,
      instanceLinkUUID
    );
  }

  const populatedPropertys = populatePropertys({
    capDestProp: true,
    propertyNames: [
      'beforeThreshold',
      'linkedProfileUUID',
      'profileUUID',
      'questionSetId'
    ],
    source: props
  });

  return axios({
    method,
    params: populatedPropertys,
    url,
    ...requestConfig
  });
};

export default getInstancesQuestionsOptions;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/getInstancesQuestionsOptions.js